import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=4fc57268&scoped=true&"
import script from "./SystemError.vue?vue&type=script&lang=ts&"
export * from "./SystemError.vue?vue&type=script&lang=ts&"
import style0 from "./SystemError.vue?vue&type=style&index=0&id=4fc57268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc57268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
